(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["enigmax-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initSlider(el) {
      var track = el.querySelector('[data-track]');
      if (!track) return;
      var slides = track.children;
      if (slides.length < 2) return;

      var dots = el.querySelectorAll('[data-dot]');
      var autoplay = parseInt(el.getAttribute('data-autoplay'), 10) || 0;
      var current = 0;
      var timer = null;

      function updateDots() {
        for (var i = 0; i < dots.length; i++) {
          dots[i].classList.toggle('is-active', i === current);
        }
      }
      function goTo(i) {
        current = (i + slides.length) % slides.length;
        track.scrollTo({ left: slides[current].offsetLeft, behavior: 'smooth' });
        updateDots();
      }
      function start() {
        if (autoplay > 0) {
          timer = setInterval(function () { goTo(current + 1); }, autoplay);
        }
      }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      function restart() { stop(); start(); }

      for (var d = 0; d < dots.length; d++) {
        (function (dot) {
          dot.addEventListener('click', function () {
            goTo(parseInt(dot.getAttribute('data-dot'), 10));
            restart();
          });
        })(dots[d]);
      }
      var prev = el.querySelector('[data-prev]');
      var next = el.querySelector('[data-next]');
      if (prev) prev.addEventListener('click', function () { goTo(current - 1); restart(); });
      if (next) next.addEventListener('click', function () { goTo(current + 1); restart(); });

      var scrollTimer;
      track.addEventListener('scroll', function () {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(function () {
          var idx = Math.round(track.scrollLeft / track.clientWidth);
          if (idx !== current && idx >= 0 && idx < slides.length) {
            current = idx;
            updateDots();
          }
        }, 90);
      });

      el.addEventListener('mouseenter', stop);
      el.addEventListener('mouseleave', restart);
      start();
    }

    function initAll() {
      var sliders = document.querySelectorAll('[data-enigmax-hero-slider]');
      for (var i = 0; i < sliders.length; i++) initSlider(sliders[i]);
    }

    if (document.readyState !== 'loading') initAll();
    else document.addEventListener('DOMContentLoaded', initAll);
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["enigmax-presence"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function ss(lo, hi, x) {
      if (hi <= lo) return x >= hi ? 1 : 0;
      var t = Math.max(0, Math.min(1, (x - lo) / (hi - lo)));
      return t * t * (3 - 2 * t);
    }

    function initEpx(root) {
      if (root.dataset.epxReady === '1') return;
      // ENIGMA-X: section is hidden on mobile (CSS), so skip the scroll/paint
      // loop entirely there — nothing to render and it saves the rAF work.
      if (window.matchMedia && window.matchMedia('(max-width: 749px)').matches) return;
      root.dataset.epxReady = '1';

      var canvas = root.querySelector('[data-epx-canvas]');
      if (!canvas) return;
      var ctx = canvas.getContext('2d', { alpha: false });
      var prog = root.querySelector('[data-epx-prog]');
      var intro = root.querySelector('[data-epx-intro]');
      var hint = root.querySelector('[data-epx-hint]');
      var panels = [].slice.call(root.querySelectorAll('[data-epx-panel]'));
      var dataEl = root.querySelector('[data-epx-frames]');
      if (!dataEl) return;

      var urls;
      try { urls = JSON.parse(dataEl.textContent); } catch (e) { return; }
      if (!urls || !urls.length) return;

      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var mobile = window.innerWidth < 750;
      if (mobile && urls.length > 40) urls = urls.filter(function (_, i) { return i % 2 === 0; });

      var N = urls.length;
      var imgs = new Array(N).fill(null);
      var fExact = 0, targetF = 0, prc = 0, hintHidden = false;
      var W = 0, H = 0, dpr = Math.min(window.devicePixelRatio || 1, 2);

      // pre-parse panel windows
      var pw = panels.map(function (p) {
        var from = (parseFloat(p.getAttribute('data-from')) || 0) / 100;
        var to = (parseFloat(p.getAttribute('data-to')) || 100) / 100;
        var ramp = Math.min(0.05, Math.max(0.01, (to - from) * 0.35));
        return { el: p, from: from, to: to, ramp: ramp, center: p.classList.contains('epx__panel--center') };
      });

      function resize() {
        dpr = Math.min(window.devicePixelRatio || 1, 2);
        var r = canvas.getBoundingClientRect();
        W = Math.max(1, Math.round(r.width * dpr));
        H = Math.max(1, Math.round(r.height * dpr));
        canvas.width = W; canvas.height = H;
      }

      function draw(idx) {
        ctx.fillStyle = '#000'; ctx.fillRect(0, 0, W, H);
        var im = imgs[idx];
        if (!im) return;
        var iw = im.naturalWidth, ih = im.naturalHeight;
        var scale = Math.max(W / iw, H / ih);
        var dw = iw * scale, dh = ih * scale;
        ctx.drawImage(im, (W - dw) / 2, (H - dh) / 2, dw, dh);
      }

      // read progress from the section's viewport position — works no matter
      // which element is the scroll container (window OR .page-wrapper)
      function computeProgress() {
        var rect = root.getBoundingClientRect();
        var scrollable = rect.height - window.innerHeight;
        prc = scrollable > 0 ? Math.max(0, Math.min(1, -rect.top / scrollable)) : 0;
        targetF = prc * (N - 1);
        return rect;
      }

      function updateOverlays() {
        if (prog) prog.style.width = (prc * 100) + '%';
        if (intro) intro.style.opacity = String(1 - ss(0.04, 0.18, prc));
        if (hint && !hintHidden && prc > 0.02) { hintHidden = true; hint.classList.add('is-hidden'); }
        for (var i = 0; i < pw.length; i++) {
          var p = pw[i];
          var vis = ss(p.from, p.from + p.ramp, prc) * (1 - ss(p.to - p.ramp, p.to, prc));
          p.el.style.opacity = String(vis);
          var dy = (1 - vis) * 24;
          p.el.style.transform = p.center
            ? 'translate(-50%, calc(-50% + ' + dy + 'px))'
            : 'translateY(calc(-50% + ' + dy + 'px))';
        }
      }

      function loop() {
        var rect = computeProgress();
        // only paint when the stage is on/near screen
        if (rect.bottom > -100 && rect.top < window.innerHeight + 100) {
          fExact += (targetF - fExact) * 0.14;
          var idx = Math.round(fExact);
          if (idx < 0) idx = 0; else if (idx > N - 1) idx = N - 1;
          draw(idx);
          updateOverlays();
        }
        requestAnimationFrame(loop);
      }

      window.addEventListener('resize', function () { resize(); draw(Math.round(fExact)); }, { passive: true });

      function loadOne(i) {
        return new Promise(function (res) {
          var im = new Image();
          im.decoding = 'async';
          im.onload = im.onerror = function () {
            imgs[i] = (im.complete && im.naturalWidth) ? im : null;
            res();
          };
          im.src = urls[i];
        });
      }

      resize();
      computeProgress();
      fExact = targetF;

      (async function () {
        var eager = [];
        for (var i = 0; i < Math.min(16, N); i++) eager.push(loadOne(i));
        await Promise.all(eager);
        if (reduce) { draw(N - 1); prc = 1; updateOverlays(); }
        else { requestAnimationFrame(loop); }
        for (var j = 16; j < N; j += 12) {
          var batch = [];
          for (var k = j; k < Math.min(j + 12, N); k++) batch.push(loadOne(k));
          await Promise.all(batch);
        }
      })();
    }

    function init() {
      var roots = document.querySelectorAll('[data-epx]');
      for (var i = 0; i < roots.length; i++) initEpx(roots[i]);
    }
    if (document.readyState !== 'loading') init();
    else document.addEventListener('DOMContentLoaded', init);
    document.addEventListener('shopify:section:load', function (e) {
      var scope = e.target && e.target.querySelector ? e.target : document;
      var el = scope.querySelector('[data-epx]') || document.querySelector('[data-epx]');
      if (el) initEpx(el);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["enigmax-product"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initPdp(root) {
      // ---------- Gallery ----------
      // The stage is a real scroll-snap scroller, so swiping is the browser's
      // job. This code only keeps the thumbnails in sync in both directions.
      const stage = root.querySelector('[data-enigmax-stage]');
      const slides = Array.prototype.slice.call(root.querySelectorAll('[data-enigmax-slide]'));
      const thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-enigmax-thumb]'));
      let idx = 0;

      // Brings a thumb into view by scrolling ONLY the thumbnail rail.
      // scrollIntoView() would scroll every scrollable ancestor including the
      // document — and since the rail sits below the fold on mobile, that
      // yanked the page down on every swipe.
      const rail = root.querySelector('[data-enigmax-thumbs]');
      function revealThumb(t) {
        if (!rail || !t) return;
        if (rail.scrollWidth > rail.clientWidth) {
          const left = t.offsetLeft - rail.offsetLeft;
          rail.scrollTo({ left: left - (rail.clientWidth - t.clientWidth) / 2, behavior: 'smooth' });
        } else if (rail.scrollHeight > rail.clientHeight) {
          const top = t.offsetTop - rail.offsetTop;
          rail.scrollTo({ top: top - (rail.clientHeight - t.clientHeight) / 2, behavior: 'smooth' });
        }
      }

      // Marks a thumb active. Never scrolls the stage — that would feed back
      // into the stage's own scroll handler and fight the user's finger.
      function markActive(i) {
        if (!thumbs.length || i === idx) return;
        idx = i;
        thumbs.forEach(function (x, n) {
          const on = n === i;
          x.classList.toggle('is-active', on);
          if (on) x.setAttribute('aria-current', 'true');
          else x.removeAttribute('aria-current');
        });
        revealThumb(thumbs[i]);
      }

      // Moves the stage. The scroll handler then calls markActive.
      // Slides are exactly one stage-width each, so index * clientWidth is the
      // scroll offset — no offsetLeft/offsetParent maths that the sticky
      // gallery wrapper would otherwise skew.
      function goTo(i) {
        if (!stage || !slides.length) return;
        const clamped = Math.max(0, Math.min(slides.length - 1, i));
        stage.scrollTo({ left: clamped * stage.clientWidth, behavior: 'smooth' });
      }

      if (stage && slides.length) {
        let ticking = false;
        stage.addEventListener(
          'scroll',
          function () {
            if (ticking) return;
            ticking = true;
            requestAnimationFrame(function () {
              ticking = false;
              const width = stage.clientWidth;
              if (!width) return;
              markActive(Math.max(0, Math.min(slides.length - 1, Math.round(stage.scrollLeft / width))));
            });
          },
          { passive: true }
        );

        // An orientation change resizes the slides but leaves scrollLeft where
        // it was, parking the track between two images. Re-align to the current
        // one, instantly — a smooth scroll here reads as a glitch.
        let resizeTimer = 0;
        window.addEventListener(
          'resize',
          function () {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(function () {
              stage.scrollTo({ left: idx * stage.clientWidth, behavior: 'auto' });
            }, 150);
          },
          { passive: true }
        );
      }

      thumbs.forEach(function (t, i) {
        t.addEventListener('click', function () {
          goTo(i);
          markActive(i); // immediate feedback; the scroll sync agrees a frame later
        });
      });

      const prevBtn = root.querySelector('[data-enigmax-prev]');
      const nextBtn = root.querySelector('[data-enigmax-next]');
      if (prevBtn) prevBtn.addEventListener('click', function () { goTo(idx - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { goTo(idx + 1); });
      const select = root.querySelector('[data-enigmax-variant-select]');
      if (select) {
        select.addEventListener('change', function () {
          const opt = select.options[select.selectedIndex];
          const now = root.querySelector('[data-enigmax-price-now]');
          const was = root.querySelector('[data-enigmax-price-was]');
          if (now && opt.dataset.price) now.textContent = opt.dataset.price;
          if (was) {
            if (opt.dataset.compare) { was.textContent = opt.dataset.compare; was.hidden = false; }
            else { was.textContent = ''; was.hidden = true; }
          }

          // Keep ?variant= in sync with the selection. App blocks rendered in
          // the outlet below the buy buttons (Razorpay Buy Now, COD widgets) sit
          // outside this form and read the selected variant from the URL — the
          // theme's own add-to-cart posts the <select> value so it was never
          // affected, which is why this went unnoticed. Without it an app
          // checkout button always buys the default variant.
          try {
            var url = new URL(window.location.href);
            url.searchParams.set('variant', select.value);
            window.history.replaceState({}, '', url);
          } catch (e) {}

          // Some app blocks listen for a change event instead of polling the URL.
          document.dispatchEvent(new CustomEvent('variant:change', {
            detail: { variantId: select.value, productId: root.dataset.productId }
          }));
        });
      }
    }
    document.querySelectorAll('.enigmax-pdp').forEach(initPdp);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["enigmax-testimonials"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initTestimonials(root) {
      const track = root.querySelector('[data-enigmax-tst-track]');
      if (!track) return;
      const prev = root.querySelector('[data-enigmax-tst-prev]');
      const next = root.querySelector('[data-enigmax-tst-next]');
      const current = root.querySelector('[data-enigmax-tst-current]');
      const cards = Array.from(track.children);
      if (!cards.length) return;

      function step() {
        return cards[0].getBoundingClientRect().width + 20;
      }
      function updateCounter() {
        const index = Math.round(track.scrollLeft / step());
        const clamped = Math.min(Math.max(index, 0), cards.length - 1);
        if (current) current.textContent = String(clamped + 1).padStart(2, '0');
      }
      prev && prev.addEventListener('click', function () {
        track.scrollBy({ left: -step(), behavior: 'smooth' });
      });
      next && next.addEventListener('click', function () {
        track.scrollBy({ left: step(), behavior: 'smooth' });
      });
      track.addEventListener('scroll', function () {
        window.requestAnimationFrame(updateCounter);
      });
    }
    document.querySelectorAll('.enigmax-tst').forEach(initTestimonials);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
